import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IReactable } from '../../models/extension.model';

@Component({
  selector: 'dc-reactions-viewer',
  template: `<pre>{{ data() | json }}</pre>`,
  standalone: true,
  imports: [CommonModule],
})
export class DcReactionsViewerComponent {
  data = input.required<IReactable>();
}
